import Vue from 'vue'
// import ServerValidationError from "@/helpers/ServerValidationError";
import axios from 'axios'
import request from '@/helpers/request'
import store from '@/store/index'

export default {
  SESSION_OPEN: ({ commit, state, rootState }, payload = {}) => {
    if (payload.user?.unit?.company_id === 5) {
      return request(
        'POST',
        `${Vue.config.server}/${Vue.config.modules.crm.api.KKM.openShift}`,
        {
          data: { user_id: payload.user.id },
          headers: {
            Accept: 'application/json',
          },
        },
        true,
      )
    }

    const kkmDomain = rootState.user.unit.settings.kkmBaseUrl
    const kkmSettings = rootState.user.unit.settings.kkmSettings

    kkmSettings.ValueOfFieldString = payload.params.ValueOfFieldString

    payload.params = kkmSettings
    return axios({
      method: 'POST',
      url: `${kkmDomain}${Vue.config.modules.crm.api.KKM.sessionOpen}`,
      data: payload,
    })
  },
  SESSION_CLOSE: ({ commit, state, rootState }, payload = {}) => {
    if (payload.user?.unit?.company_id === 5) {
      return request(
        'POST',
        `${Vue.config.server}/${Vue.config.modules.crm.api.KKM.closeShift}`,
        {
          data: { user_id: payload.user.id },
          headers: {
            Accept: 'application/json',
          },
        },
        true,
      )
    }

    const { kkmBaseUrl, kkmSettings } = rootState.user.unit.settings

    return axios({
      method: 'POST',
      url: `${kkmBaseUrl}${Vue.config.modules.crm.api.KKM.sessionClose}`,
      data: { params: { ...kkmSettings, ...payload.params } },
    })
  },
  PRINT_QR: ({ commit, state, rootState }, payload) => {
    const kkmDomain = rootState.user.unit.settings.kkmBaseUrl
    const kkmSettings = rootState.user.unit.settings.kkmSettings

    kkmSettings.ValueOfFieldString = payload.params.ValueOfFieldString

    payload.params = kkmSettings
    return new Promise((resolve, reject) => {
      axios({
        method: 'POST',
        url: `${kkmDomain}${Vue.config.modules.crm.api.KKM.printQR}`,
        data: payload,
      })
        .then(function (response) {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  CHECK: ({ commit, state, rootState }, payload) => {
    if (payload.order?.unit?.company_id === 5) {
      return request(
        'POST',
        `${Vue.config.server}/${Vue.config.modules.crm.api.KKM.sendReceipt}`,
        {
          data: { order_id: payload.order.id },
          headers: {
            'Content-Type': 'application/json',
          },
        },
        true,
      )
    }

    const kkmDomain = rootState.user.unit.settings.kkmBaseUrl
    const kkmSettings = rootState.user.unit.settings.kkmSettings

    kkmSettings.ValueOfFieldString = payload.data.params.ValueOfFieldString

    payload.data.params = kkmSettings
    return new Promise((resolve, reject) => {
      axios({
        method: 'POST',
        url: `${kkmDomain}${Vue.config.modules.crm.api.KKM.check}`,
        data: payload.data,
      })
        .then(function (response) {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  REFUND: ({ commit, state, rootState }, payload) => {
    const kkmDomain = rootState.user.unit.settings.kkmBaseUrl
    const kkmSettings = rootState.user.unit.settings.kkmSettings

    kkmSettings.ValueOfFieldString = payload.params.ValueOfFieldString

    payload.params = kkmSettings
    return new Promise((resolve, reject) => {
      axios({
        method: 'POST',
        url: `${kkmDomain}${Vue.config.modules.crm.api.KKM.refund}`,
        data: payload,
      })
        .then(function (response) {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },

  GET_NEW_FILES: async ({ commit, state, rootState }) => {
    try {
      const kkmDomain = rootState.user.unit.settings.kkmBaseUrl
      const response = await fetch(`${kkmDomain}${Vue.config.modules.crm.api.KKM.files}`)
      const responseData = await response.json()

      const fileLinks = []

      for (const index in responseData.data) {
        fileLinks.push({
          link: `${kkmDomain}${Vue.config.modules.crm.api.KKM.files}/${responseData.data[index]}?${Math.random()}`,
          name: responseData.data[index],
          selected: false,
          disable: false,
        })
      }

      return fileLinks
    } catch (e) {
      console.log(e)
      return []
    }
  },

  SAVE_NEW_FILES: async ({ commit, rootState }, array) => {
    const resultArray = []
    const kkmDomain = rootState.user.unit.settings.kkmBaseUrl

    for (let i = 0; i < array.length; i++) {
      const fileFetch = await fetch(
        `${kkmDomain}${Vue.config.modules.crm.api.KKM.files}/${array[i].name}?${Math.random()}`,
      )
      if (fileFetch.status !== 200) continue
      array[i].blob = await fileFetch.blob()
      resultArray.push(array[i])
    }

    return resultArray
  },

  GET_FILES: async ({ commit, state, rootState }, array) => {
    const kkmDomain = rootState.user.unit.settings.kkmBaseUrl
    const response = await fetch(`${kkmDomain}${Vue.config.modules.crm.api.KKM.files}`)

    const responseData = await response.json()

    const files = []
    const fileNames = []

    for (const index in responseData.data) {
      fileNames.push(responseData.data[index])
      const fileFetch = await fetch(`${kkmDomain}${Vue.config.modules.crm.api.KKM.files}/${responseData.data[index]}`)
      const data = await fileFetch.blob()
      await files.push(data)
    }

    return { fileNames: fileNames, files: files }
  },

  DROP_FILES: async ({ commit, state, rootState }, params) => {
    const kkmDomain = rootState.user.unit.settings.kkmBaseUrl
    for (const index in params) {
      try {
        if (params[index].selected)
          await fetch(`${kkmDomain}${Vue.config.modules.crm.api.KKM.files}/remove/${params[index].name}`)
      } catch (e) {
        console.info(e)
      }
    }

    return true
  },

  SEND_X_REPORT: ({ commit, state, rootState }, payload) => {
    const kkmDomain = rootState.user.unit.settings.kkmBaseUrl
    const kkmSettings = rootState.user.unit.settings.kkmSettings

    kkmSettings.ValueOfFieldString = payload.params.ValueOfFieldString

    return new Promise((resolve, reject) => {
      axios({
        method: 'POST',
        url: `${kkmDomain}${Vue.config.modules.crm.api.KKM.reportX}`,
        data: {
          params: kkmSettings,
        },
      })
        .then(function (response) {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
}
